import React, { useState, useEffect, useContext } from "react";

import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";

import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Table from "react-bootstrap/Table";
import Col from "react-bootstrap/esm/Col";

import Accordion from 'react-bootstrap/Accordion';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import ProgressBar from 'react-bootstrap/ProgressBar';

import ButtonGroup from 'react-bootstrap/ButtonGroup';

import { permite_acesso, total_monitora, metas_unidades, novos_renovados_unidade, anuidade_unidades } from "../../services/api";

const Metas_unidade = (props) => {

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    const perfil = JSON.parse(localStorage.getItem("perfil"));

    const meu_perfil = perfil[0].perfil;

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];


    const [data26, setData26] = useState([]);
    const [dataA, setDataA] = useState([]);
    const [dataM, setDataM] = useState([]);

    const fetchData = async () => {
        try {
            const response = await anuidade_unidades(data_inicio, data_fim);
            setDataA(response);
            const responseM = await metas_unidades(data_inicio, data_fim);
            setDataM(responseM);
            console.log("DATA26: i F", data_inicio, data_fim);
            const response3 = await novos_renovados_unidade(data_inicio, data_fim);
            setData26(response3);

        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);


    console.log("DATA26:", data26);

    let Total = 0;
    let indice = 0;
    let Renovados = 0;
    if (typeof data26 !== 'undefined') {
        indice = data26.findIndex(data26 => data26.unidade === cod_unidade)

        console.log("indice ", indice)
    };

    if (indice !== -1) {
        Total = parseInt(data26[indice].novos) + parseInt(data26[indice].renovados) + parseInt(data26[indice].regressos)
        Renovados = parseInt(data26[indice].renovados);
    }

    let anuidade_ajustada = 0;
    let indiceA = 0;
    if (typeof dataA !== 'undefined') {
        indiceA = dataA.findIndex(dataA => dataA.sec === cod_unidade)

        console.log("indiceA ", indiceA)
    };

    if (indiceA !== -1) {
        anuidade_ajustada = parseFloat(dataA[indiceA].anuidade_ajustada)
    }

    // "finan1": "7377341.84",
    // "finan2": "7524427.82",
    // "fidelizacao1": "750",
    // "fidelizacao2": "764",
    // "total1": "954",
    // "total2": "982"

    let indiceM = 0;

    let finan1 = 0;
    let finan2 = 0;
    let finan3 = 0;

    let fidelizacao1 = 0;
    let fidelizacao2 = 0;
    let fidelizacao3 = 0;

    let total1 = 0;
    let total2 = 0;
    let total3 = 0;


    if (typeof dataM !== 'undefined') {
        indiceM = dataM.findIndex(dataM => dataM.unidade === cod_unidade)
        console.log("indiceM ", indiceM)
    };

    if (indiceM !== -1) {
        finan1 = parseFloat(dataM[indiceM].finan1);
        finan2 = parseFloat(dataM[indiceM].finan2);
        finan3 = parseFloat(dataM[indiceM].finan3);
        fidelizacao1 = parseInt(dataM[indiceM].fidelizacao1);
        fidelizacao2 = parseInt(dataM[indiceM].fidelizacao2);
        fidelizacao3 = parseInt(dataM[indiceM].fidelizacao3);
        total1 = parseInt(dataM[indiceM].total1);
        total2 = parseInt(dataM[indiceM].total2);
        total3 = parseInt(dataM[indiceM].total3);

    }

    let fina1F = finan1.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', });
    let fina2F = finan2.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', });
    let fina3F = finan3.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', });

    let faltaF1F = (finan1 - anuidade_ajustada).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', });
    let sobra1F = (anuidade_ajustada - finan1).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', });

    let faltaF2F = (finan2 - anuidade_ajustada).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', });
    let sobra2F = (anuidade_ajustada - finan2).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', });

    let faltaF3F = (finan3 - anuidade_ajustada).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', });
    let sobra3F = (anuidade_ajustada - finan3).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', });

    let PercentualMetaFinan1 = Math.round(((anuidade_ajustada * 100) / finan1) * 100) / 100;
    let PercentualMetaFinan2 = Math.round(((anuidade_ajustada * 100) / finan2) * 100) / 100;
    let PercentualMetaFinan3 = Math.round(((anuidade_ajustada * 100) / finan3) * 100) / 100;

    let PercentualMetal1 = (Total * 100) / total1;
    let PercentualMetal2 = (Total * 100) / total2;
    let PercentualMetal3 = (Total * 100) / total3;

    let APercentualMetal1 = Math.round(PercentualMetal1 * 100) / 100;
    let APercentualMetal2 = Math.round(PercentualMetal2 * 100) / 100;
    let APercentualMetal3 = Math.round(PercentualMetal3 * 100) / 100;

    let PercentualMetaReno1 = (Renovados * 100) / fidelizacao1;
    let PercentualMetaReno2 = (Renovados * 100) / fidelizacao2;
    let PercentualMetaReno3 = (Renovados * 100) / fidelizacao3;

    let APercentualMetaReno1 = Math.round(PercentualMetaReno1 * 100) / 100;
    let APercentualMetaReno2 = Math.round(PercentualMetaReno2 * 100) / 100;
    let APercentualMetaReno3 = Math.round(PercentualMetaReno3 * 100) / 100;

    console.log("Total ", Total)

    const getProgressBarVariant = (percentage) => {
        if (percentage >= 100) {
            return 'success'; // Verde
        }
        if (percentage >= 90) {
            return 'info'; // Azul/Ciano claro (ou 'primary' para um azul mais escuro)
        }
        if (percentage >= 75) {
            return 'warning'; // Laranja
        }
        return 'danger'; // Vermelho
    };


    if (meu_perfil.startsWith("SECRETARIA")) {
        return (
            <div className="metas">
                <CardGroup>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (total1 - Total) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #cd7f32, #a95c1f)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.ImgOverlay>
                                <Card.Title> {(total1 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                    <span style={{ fontWeight: ((total1 - Total)) <= 0 ? 'bold' : 'normal', }}> Meta de Alunos 1 </span>
                                    {(total1 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                                <Card.Subtitle >{cod_unidade === '99' ? '2026 + 20% ' : '2026 + 1%'} </Card.Subtitle>
                                <Card.Text>
                                    Meta: <b>{total1}</b> Alunos
                                    {(total1 - Total) >= 0
                                        ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${total1 - Total}</strong> Alunos ` }} />
                                        : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Total - total1}</strong> Alunos a Meta 1 ` }} />
                                    }
                                    <ProgressBar
                                        now={APercentualMetal1}
                                        label={`${APercentualMetal1}%`}
                                        style={{ height: '26px', fontSize: '0.9rem' }}
                                        animated={APercentualMetal1 < 100}
                                        striped
                                        variant={getProgressBarVariant(APercentualMetal1)} // <-- A MÁGICA ACONTECE AQUI!
                                    />
                                    A unidade tem <b> {APercentualMetal1} % </b>  da Meta 1
                                </Card.Text>

                            </Card.ImgOverlay>

                        </Card.Body>
                    </Card>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (total2 - Total) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #c0c0c0, #808080)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(total2 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: ((total2 - Total)) <= 0 ? 'bold' : 'normal', }}> Meta de Alunos 2 </span>
                                {(total2 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Subtitle >{cod_unidade === '99' ? '2026 + 26% ' : '2026 + 3%'} </Card.Subtitle>
                            <Card.Text>
                                Meta: <b>{total2}</b> Alunos
                                {(total2 - Total) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${total2 - Total}</strong> Alunos ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Total - total2}</strong> Alunos a Meta 2 ` }} />
                                }
                                <ProgressBar
                                    now={APercentualMetal2}
                                    label={`${APercentualMetal2}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={APercentualMetal2 < 100}
                                    striped
                                    variant={getProgressBarVariant(APercentualMetal2)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {APercentualMetal2} % </b>  da Meta 2
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (total3 - Total) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #ffd700, #b8860b)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(total3 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: ((total3 - Total)) <= 0 ? 'bold' : 'normal', }}> Meta de Alunos 3 </span>
                                {(total3 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Subtitle >{cod_unidade === '99' ? '2026 + 30% ' : '2026 + 6%'} </Card.Subtitle>
                            <Card.Text>
                                Meta: <b>{total3}</b> Alunos
                                {(total3 - Total) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${total3 - Total}</strong> Alunos ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Total - total3}</strong> Alunos a Meta 3 ` }} />
                                }
                                <ProgressBar
                                    now={APercentualMetal3}
                                    label={`${APercentualMetal3}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={APercentualMetal3 < 100}
                                    striped
                                    variant={getProgressBarVariant(APercentualMetal3)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {APercentualMetal3} % </b>  da Meta 3
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </CardGroup>
                <CardGroup>
                    <Card className="card text-center"
                    >

                        <Card.Body style={{
                            background: (fidelizacao1 - Renovados) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #cd7f32, #a95c1f)', // Gradiente original

                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(fidelizacao1 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: (fidelizacao1 - Renovados) <= 0 ? 'bold' : 'normal', }}> Meta de Fidelização 1 </span>
                                {(fidelizacao1 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Text>
                                Meta: <b>{fidelizacao1} </b> Alunos
                                {(fidelizacao1 - Renovados) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${fidelizacao1 - Renovados}</strong> Alunos ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Renovados - fidelizacao1}</strong> Alunos a Meta 1 ` }} />
                                }
                                <ProgressBar
                                    now={APercentualMetaReno1}
                                    label={`${APercentualMetaReno1}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={APercentualMetaReno1 < 100}
                                    striped
                                    variant={getProgressBarVariant(APercentualMetaReno1)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {APercentualMetaReno1} % </b>  da Meta 1
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (fidelizacao2 - Renovados) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #c0c0c0, #808080)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(fidelizacao2 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: (fidelizacao2 - Renovados) <= 0 ? 'bold' : 'normal', }}> Meta de Fidelização 2 </span>
                                {(fidelizacao2 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Text>
                                Meta: <b> {fidelizacao2} </b> Alunos
                                {(fidelizacao2 - Renovados) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${fidelizacao2 - Renovados}</strong> Alunos ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Renovados - fidelizacao2}</strong> Alunos a Meta 2 ` }} />
                                }
                                <ProgressBar
                                    now={APercentualMetaReno2}
                                    label={`${APercentualMetaReno2}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={APercentualMetaReno2 < 100}
                                    striped
                                    variant={getProgressBarVariant(APercentualMetaReno2)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {APercentualMetaReno2} % </b> da Meta 2
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (fidelizacao3 - Renovados) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #ffd700, #b8860b)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(fidelizacao3 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: (fidelizacao3 - Renovados) <= 0 ? 'bold' : 'normal', }}> Meta de Fidelização 3 </span>
                                {(fidelizacao3 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Text>
                                Meta: <b> {fidelizacao3} </b> Alunos
                                {(fidelizacao3 - Renovados) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${fidelizacao3 - Renovados}</strong> Alunos ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Renovados - fidelizacao3}</strong> Alunos a Meta 3 ` }} />
                                }
                                <ProgressBar
                                    now={APercentualMetaReno3}
                                    label={`${APercentualMetaReno3}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={APercentualMetaReno3 < 100}
                                    striped
                                    variant={getProgressBarVariant(APercentualMetaReno3)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {APercentualMetaReno3} % </b> da Meta 3
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </CardGroup>

            </div>
        );
    }
    else {
        return (
            <div className="metas">
                <CardGroup>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (total1 - Total) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #cd7f32, #a95c1f)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.ImgOverlay>
                                <Card.Title> {(total1 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                    <span style={{ fontWeight: ((total1 - Total)) <= 0 ? 'bold' : 'normal', }}> Meta de Alunos 1 </span>
                                    {(total1 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                                <Card.Subtitle >{cod_unidade === '99' ? '2026 + 20% ' : '2026 + 1%'} </Card.Subtitle>
                                <Card.Text>
                                    Meta: <b>{total1}</b> Alunos
                                    {(total1 - Total) >= 0
                                        ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${total1 - Total}</strong> Alunos ` }} />
                                        : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Total - total1}</strong> Alunos a Meta 1 ` }} />
                                    }
                                    <ProgressBar
                                        now={APercentualMetal1}
                                        label={`${APercentualMetal1}%`}
                                        style={{ height: '26px', fontSize: '0.9rem' }}
                                        animated={APercentualMetal1 < 100}
                                        striped
                                        variant={getProgressBarVariant(APercentualMetal1)} // <-- A MÁGICA ACONTECE AQUI!
                                    />
                                    A unidade tem <b> {APercentualMetal1} % </b>  da Meta 1
                                    <br />
                                </Card.Text>

                            </Card.ImgOverlay>

                        </Card.Body>
                    </Card>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (total2 - Total) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #c0c0c0, #808080)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(total2 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: ((total2 - Total)) <= 0 ? 'bold' : 'normal', }}> Meta de Alunos 2 </span>
                                {(total2 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Subtitle >{cod_unidade === '99' ? '2026 + 26% ' : '2026 + 3%'} </Card.Subtitle>
                            <Card.Text>
                                Meta: <b>{total2}</b> Alunos
                                {(total2 - Total) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${total2 - Total}</strong> Alunos ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Total - total2}</strong> Alunos a Meta 2 ` }} />
                                }
                                <ProgressBar
                                    now={APercentualMetal2}
                                    label={`${APercentualMetal2}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={APercentualMetal2 < 100}
                                    striped
                                    variant={getProgressBarVariant(APercentualMetal2)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {APercentualMetal2} % </b>  da Meta 2
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (total3 - Total) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #ffd700, #b8860b)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(total3 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: ((total3 - Total)) <= 0 ? 'bold' : 'normal', }}> Meta de Alunos 3 </span>
                                {(total3 - Total) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Subtitle >{cod_unidade === '99' ? '2026 + 30% ' : '2026 + 6%'} </Card.Subtitle>
                            <Card.Text>
                                Meta: <b>{total3}</b> Alunos
                                {(total3 - Total) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${total3 - Total}</strong> Alunos ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Total - total3}</strong> Alunos a Meta 3 ` }} />
                                }
                                <ProgressBar
                                    now={APercentualMetal3}
                                    label={`${APercentualMetal3}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={APercentualMetal3 < 100}
                                    striped
                                    variant={getProgressBarVariant(APercentualMetal3)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {APercentualMetal3} % </b>  da Meta 3
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </CardGroup>
                <CardGroup>
                    <Card className="card text-center"
                    >

                        <Card.Body style={{
                            background: (fidelizacao1 - Renovados) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #cd7f32, #a95c1f)', // Gradiente original

                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(fidelizacao1 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: (fidelizacao1 - Renovados) <= 0 ? 'bold' : 'normal', }}> Meta de Fidelização 1 </span>
                                {(fidelizacao1 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Text>
                                Meta: <b>{fidelizacao1} </b> Alunos
                                {(fidelizacao1 - Renovados) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${fidelizacao1 - Renovados}</strong> Alunos ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Renovados - fidelizacao1}</strong> Alunos a Meta 1 ` }} />
                                }
                                <ProgressBar
                                    now={APercentualMetaReno1}
                                    label={`${APercentualMetaReno1}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={APercentualMetaReno1 < 100}
                                    striped
                                    variant={getProgressBarVariant(APercentualMetaReno1)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {APercentualMetaReno1} % </b>  da Meta 1
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (fidelizacao2 - Renovados) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #c0c0c0, #808080)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(fidelizacao2 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: (fidelizacao2 - Renovados) <= 0 ? 'bold' : 'normal', }}> Meta de Fidelização 2 </span>
                                {(fidelizacao2 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Text>
                                Meta: <b> {fidelizacao2} </b> Alunos
                                {(fidelizacao2 - Renovados) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${fidelizacao2 - Renovados}</strong> Alunos ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Renovados - fidelizacao2}</strong> Alunos a Meta 2 ` }} />
                                }
                                <ProgressBar
                                    now={APercentualMetaReno2}
                                    label={`${APercentualMetaReno2}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={APercentualMetaReno2 < 100}
                                    striped
                                    variant={getProgressBarVariant(APercentualMetaReno2)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {APercentualMetaReno2} % </b> da Meta 2
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (fidelizacao3 - Renovados) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #ffd700, #b8860b)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(fidelizacao3 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: (fidelizacao3 - Renovados) <= 0 ? 'bold' : 'normal', }}> Meta de Fidelização 3 </span>
                                {(fidelizacao3 - Renovados) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Text>
                                Meta: <b> {fidelizacao3} </b> Alunos
                                {(fidelizacao3 - Renovados) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: ` Faltam: <strong>${fidelizacao3 - Renovados}</strong> Alunos ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: ` Supera em: <strong>${Renovados - fidelizacao3}</strong> Alunos a Meta 3 ` }} />
                                }
                                <ProgressBar
                                    now={APercentualMetaReno3}
                                    label={`${APercentualMetaReno3}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={APercentualMetaReno3 < 100}
                                    striped
                                    variant={getProgressBarVariant(APercentualMetaReno3)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {APercentualMetaReno3} % </b> da Meta 3
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </CardGroup>
                <CardGroup>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (finan1 - anuidade_ajustada) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #cd7f32, #a95c1f)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(finan1 - anuidade_ajustada) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: ((finan1 - anuidade_ajustada)) <= 0 ? 'bold' : 'normal', }}> Meta Financeira 1 </span>
                                {(finan1 - anuidade_ajustada) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Text>
                                Meta: <b>{fina1F} </b>
                                {(finan1 - anuidade_ajustada) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: `Faltam: <strong>${faltaF1F}</strong> ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: `Supera em: <strong>${sobra1F}</strong> a Meta 1` }} />
                                }
                                <ProgressBar
                                    now={PercentualMetaFinan1}
                                    label={`${PercentualMetaFinan1}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={PercentualMetaFinan1 < 100}
                                    striped
                                    variant={getProgressBarVariant(PercentualMetaFinan1)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {PercentualMetaFinan1} % </b>  da Meta 1
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (finan2 - anuidade_ajustada) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #c0c0c0, #808080)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(finan2 - anuidade_ajustada) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: ((finan2 - anuidade_ajustada)) <= 0 ? 'bold' : 'normal', }}> Meta Financeira 2 </span>
                                {(finan2 - anuidade_ajustada) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Text>
                                Meta: <b>{fina2F} </b>

                                {(finan2 - anuidade_ajustada) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: `Faltam: <strong>${faltaF2F}</strong> ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: `Supera em: <strong>${sobra2F}</strong> a Meta 2` }} />
                                }
                                <ProgressBar
                                    now={PercentualMetaFinan2}
                                    label={`${PercentualMetaFinan2}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={PercentualMetaFinan2 < 100}
                                    striped
                                    variant={getProgressBarVariant(PercentualMetaFinan2)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {PercentualMetaFinan2} % </b>  da Meta 2
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card className="card text-center">
                        <Card.Body style={{
                            background: (finan3 - anuidade_ajustada) <= 0
                                ? 'linear-gradient(135deg, #4caf50, #2e7d32)' // Gradiente verde quando a meta é cumprida
                                : 'linear-gradient(135deg, #ffd700, #b8860b)',
                            height: '100%', // Garantir que o gradiente preencha todo o card
                            color: '#fff', // Cor do texto para contraste com o gradiente
                        }}>
                            <Card.Title>{(finan3 - anuidade_ajustada) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}
                                <span style={{ fontWeight: ((finan1 - anuidade_ajustada)) <= 0 ? 'bold' : 'normal', }}> Meta Financeira 3 </span>
                                {(finan3 - anuidade_ajustada) <= 0 ? <i className="fa-solid fa-trophy"></i> : ''}</Card.Title>
                            <Card.Text>
                                Meta: <b>{fina3F} </b>

                                {(finan3 - anuidade_ajustada) >= 0
                                    ? <span dangerouslySetInnerHTML={{ __html: `Faltam: <strong>${faltaF3F}</strong> ` }} />
                                    : <span dangerouslySetInnerHTML={{ __html: `Supera em: <strong>${sobra3F}</strong> a Meta 3` }} />
                                }
                                <ProgressBar
                                    now={PercentualMetaFinan3}
                                    label={`${PercentualMetaFinan3}%`}
                                    style={{ height: '26px', fontSize: '0.9rem' }}
                                    animated={PercentualMetaFinan3 < 100}
                                    striped
                                    variant={getProgressBarVariant(PercentualMetaFinan3)} // <-- A MÁGICA ACONTECE AQUI!
                                />
                                A unidade tem <b> {PercentualMetaFinan3} % </b>  da Meta 3
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </CardGroup>
            </div>

        );

    }
};


export default Metas_unidade;